module.exports = __webpack_public_path__ + "static/media/code-example.0addc8fc.png";